import { render } from "./TicketDetailDialog.vue?vue&type=template&id=4b9f3b1f&scoped=true"
import script from "./TicketDetailDialog.vue?vue&type=script&lang=js"
export * from "./TicketDetailDialog.vue?vue&type=script&lang=js"

import "./TicketDetailDialog.vue?vue&type=style&index=0&id=4b9f3b1f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9f3b1f"]])

export default __exports__